import { Formik, Form } from 'formik'
import { IoMdAdd } from 'react-icons/io'
import FormikInput from 'components/formikFields/input'
import { validationSchema } from './utilities/schema'
import { initialValues } from './utilities/initialValues'
import Header from 'components/headers/bulletins'
import useIdentityVerification from './hook/useIdentityVerification'

const IdentityVerification = () => {
    const {
        state,
        handleSubmit,
        handleOpenModal,
        handleCloseModal,
        handleFileSelect,
        handleConfirm,
        handleChangePhoto,
    } = useIdentityVerification()

    const { selectedFile, isModalOpen, tempFile } = state

    return (
        <>
            <Header title="احراز هویت" />
            <div className="flex flex-col items-center justify-center max-h-screen p-4 bg-white">
                <h1 className="text-xl mb-8">شروع احراز هویت</h1>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ setFieldValue, errors, touched, isSubmitting }) => (
                        <Form className="w-full max-w-md space-y-6">
                            <FormikInput
                                name="nationalCode"
                                label="کد ملی"
                                placeholder="کد ملی خود را وارد کنید"
                                required
                                maxLength={10}
                            />
                            <FormikInput
                                name="phoneNumber"
                                label="شماره تلفن همراه"
                                placeholder="شماره تلفن همراه خود را وارد کنید"
                                required
                                maxLength={11}
                            />
                            <FormikInput
                                name="serialCode"
                                label="شماره سریال کد ملی"
                                placeholder="سریال پشت کارت ملی خود را وارد کنید"
                                required
                                maxLength={10}
                            />
                            <h2 className="text-end text-xs mr-4 mb-1 text-green-1 translate-y-2 bg-white inline-block px-1">
                                تصویر کارت ملی
                                <span className="text-red-1 mr-1">*</span>
                            </h2>
                            <div className="flex flex-col items-center mt-0">
                                {!selectedFile ? (
                                    <button
                                        type="button"
                                        className="flex items-center justify-center border-2 border-dashed border-opacity-50 border-green-1 rounded-lg p-28 w-full max-w-sm"
                                        onClick={handleOpenModal}
                                    >
                                        <IoMdAdd className="text-xl text-green-1" />
                                        <p className="text-black mr-1 text-sm">
                                            انتخاب تصویر
                                        </p>
                                    </button>
                                ) : (
                                    <img
                                        src={URL.createObjectURL(selectedFile)}
                                        alt="Selected"
                                        className="w-full max-w-sm rounded-lg cursor-pointer"
                                        onClick={handleOpenModal}
                                    />
                                )}
                                {errors.nationalCardPhoto &&
                                    touched.nationalCardPhoto && (
                                        <div className="text-red-1 text-sm mt-2">
                                            {errors.nationalCardPhoto}
                                        </div>
                                    )}
                            </div>

                            {isModalOpen && (
                                <div className="fixed inset-0 flex items-center justify-center h-screen bg-black bg-opacity-50 z-50 m-0">
                                    <div className="flex flex-col justify-center bg-white rounded-lg p-6 mx-3 w-full">
                                        <h2 className="text-lg mb-4 text-center">
                                            انتخاب عکس کارت ملی
                                        </h2>

                                        {!tempFile ? (
                                            <button
                                                className="px-4 py-2 bg-blue-1 text-white rounded-full"
                                                onClick={handleChangePhoto}
                                            >
                                                انتخاب عکس
                                            </button>
                                        ) : (
                                            <>
                                                <img
                                                    src={URL.createObjectURL(
                                                        tempFile
                                                    )}
                                                    alt="Preview"
                                                    className="w-full max-w-md rounded-lg shadow-lg mb-4"
                                                />

                                                <div className="grid grid-cols-3 gap-2 justify-between">
                                                    <button
                                                        type="button"
                                                        onClick={
                                                            handleChangePhoto
                                                        }
                                                        className="px-4 py-2 bg-yellow-1 text-white rounded-full"
                                                    >
                                                        تغییر عکس
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            handleConfirm(
                                                                setFieldValue
                                                            )
                                                        }
                                                        className="px-4 py-2 bg-green-1 text-white rounded-full"
                                                    >
                                                        تایید
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={
                                                            handleCloseModal
                                                        }
                                                        className="px-4 py-2 bg-gray-3 text-white rounded-full"
                                                    >
                                                        بستن
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                        <input
                                            id="fileInput"
                                            type="file"
                                            accept="image/*"
                                            className="hidden"
                                            onChange={handleFileSelect}
                                        />
                                    </div>
                                </div>
                            )}
                            <button
                                type="submit"
                                disabled={isSubmitting || !selectedFile}
                                className={`w-full px-4 py-2 text-white rounded-full ${
                                    isSubmitting || !selectedFile
                                        ? 'bg-gray-1 cursor-not-allowed'
                                        : 'bg-green-1'
                                }`}
                            >
                                {isSubmitting ? 'در حال ارسال...' : 'ادامه'}
                            </button>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}

export default IdentityVerification
